// src/data/onboarding-steps.ts
export const onboardingSteps = [
  {
    id: 'welcome',
    title: 'Welcome to Staffluent!',
    description: 'Let\'s set up your business foundation',
    content: 'Set up departments, roles, employees, and teams before using workforce features.',
    targetSelector: '[href="/"]',
    targetPath: '/',
    actionText: 'Start Setup',
    icon: 'Sparkles'
  },
  {
    id: 'departments',
    title: 'Create Departments', 
    description: 'Organize your business structure',
    content: 'Create departments like HR, Operations, Management to organize your workforce.',
    targetSelector: '[href="/departments"]',
    targetPath: '/departments',
    actionText: 'Set Up Departments',
    icon: 'Building'
  },
  {
    id: 'roles',
    title: 'Configure Roles',
    description: 'Define permissions and access',
    content: 'Choose system roles or create custom ones for your business needs.',
    targetSelector: '[href="/configuration/roles"]', 
    targetPath: '/configuration/roles',
    actionText: 'Configure Roles',
    icon: 'Shield'
  },
  {
    id: 'employees',
    title: 'Add Employees',
    description: 'Add your team members',
    content: 'Add team members with profiles, roles, and contact information.',
    targetSelector: '[href="/employees"]',
    targetPath: '/employees', 
    actionText: 'Add Employees',
    icon: 'Users'
  },
  {
    id: 'teams',
    title: 'Create Teams',
    description: 'Organize into working groups',
    content: 'Create teams within departments for projects and task management.',
    targetSelector: '[href="/teams"]',
    targetPath: '/teams',
    actionText: 'Create Teams',
    icon: 'UserCheck'
  }
];